















import Vue from "vue";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component,  Prop } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component
export default class TopNavigationComponent extends Vue {
    @Prop() schema!: any;
    @Prop() selectedKey: string;

    mounted(){
      // if(this.schema && this.schema.properties && Object.keys(this.schema.properties).length > 0){
      //   this.selectedKey = Object.keys(this.schema.properties)[0];
      // }
    }

    /** top navigation menu click event */
    menu_click(submenus, key){
      // this.selectedKey = key;
      this.$emit('click', submenus, key);
    }
}
